import { Modal, Button, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { useContext, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import {Context} from '../context/AppContext';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const AddToCartModal = ({ item, modal, setModal }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [disabledAddToCart, setDisabledAddToCart] = useState(false);
  const [alertMessages, setAlertMessages] = useState({});
  const [special_instructions, setSpecialInstructions] = useState('');
  const [quantity, setQuantity] = useState(1);
  const { language, setChangedCart, changedCart, restaurantId } = useContext(Context);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  

  useEffect(() => {
    if (!modal) {
      // Reset state when modal is closed
      setSelectedOptions([]);
      setDisabledAddToCart(false);
      setAlertMessages({});
      setSpecialInstructions('');
      setQuantity(1);
    }
  }, [modal]);

  useEffect(() => {
    const validateOptions = () => {
      let allOptionsValid = true;
      let alerts = {};
  
      item?.Restaurant_Item_Attributes.forEach((attribute) => {
        const requiredOptions = attribute?.Item_Attribute?.requ || 0;
        const maxOptions = attribute?.Item_Attribute?.max_ || 0;
        const selectedOptionsCount = selectedOptions.filter(opt => opt.attributeId === attribute.id).length;
  
        // Check for required options
        if (requiredOptions > selectedOptionsCount && requiredOptions !== 0) {
          allOptionsValid = false;
          alerts[attribute.id] = `*Must Select ${requiredOptions} options and you selected ${selectedOptionsCount}`;
        }
  
        // Check for maximum options
        if (maxOptions < selectedOptionsCount && maxOptions !== 0) {
          allOptionsValid = false;
          alerts[attribute.id] = `*Maximum of ${maxOptions} options can be selected and you selected ${selectedOptionsCount}`;
        }
  
        // Clear the alert if no issue
        if (!alerts[attribute.id]) {
          alerts[attribute.id] = '';
        }
      });
  
      setAlertMessages(alerts);
      setDisabledAddToCart(!allOptionsValid);
    };
  
    validateOptions();
  }, [selectedOptions, item]);

  const handleIncrease = () => {
    setQuantity(prevQuantity => prevQuantity + 1);
  };

  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(prevQuantity => prevQuantity - 1);
    }
  };

  const handleChange = (e) => {
    const newQuantity = parseInt(e.target.value);
    if (!isNaN(newQuantity)) {
      setQuantity(newQuantity);
    }
  };

  const handleOptionChange = (optionId, priceModifier, attributeId) => {
    const existingOption = selectedOptions.find((opt) => opt.id === optionId);

    if (existingOption) {
      // If the option is already selected, remove it
      setSelectedOptions((prevOptions) =>
        prevOptions.filter((opt) => opt.id !== optionId)
      );
    } else {
      // If the option is not selected, add it
      setSelectedOptions((prevOptions) => [
        ...prevOptions,
        { id: optionId, priceModifier, attributeId },
      ]);
    }
  };

  const calculateTotalPrice = () => {
    let totalPrice = +item?.price || 0;
    selectedOptions.forEach((option) => {
      totalPrice += +option.priceModifier || 0;
    });

    totalPrice *= +quantity;
    return totalPrice.toFixed(2);
  };

  const handleAddItem = () => {
    try {
      setIsLoading(true);
  
      const cart = JSON.parse(localStorage.getItem(`cart${restaurantId}`)) || [];
  
      const itemToAdd = {
        Item: item,
        quantity: quantity,
        special_instructions: special_instructions,
        options: selectedOptions,
        price: calculateTotalPrice(),
      };
  
      // Check if an identical item already exists in the cart
      const existingItemIndex = cart.findIndex(
        cartItem =>
          cartItem.Item.id === itemToAdd.Item.id &&
          cartItem.special_instructions === itemToAdd.special_instructions &&
          JSON.stringify(cartItem.options) === JSON.stringify(itemToAdd.options)
      );
  
      if (existingItemIndex !== -1) {
        // If the item already exists, increase its quantity
        cart[existingItemIndex].quantity += quantity;
      } else {
        // Otherwise, add the new item to the cart
        cart.push(itemToAdd);
      }
  
      localStorage.setItem(`cart${restaurantId}`, JSON.stringify(cart));
  
      setIsLoading(false);
      setSpecialInstructions('');
      setQuantity(1);
      setSelectedOptions([]);
      setModal(false);
      setChangedCart(!changedCart);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };


  

  return (
    <Modal show={modal} onHide={() => setModal(false)} centered scrollable size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{language === 'en' ? item?.name : item?.chinese_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column align-items-center">
          {item?.image_url && (
            <img
              src={item?.image_url}
              alt={language === 'en' ? item?.name : item?.chinese_name}
              className="img-fluid mb-3"
              style={{ width: '100%', maxHeight: '220px', objectFit: 'cover' }}
            />
          )}
          {item?.description && item?.description !== 'null' && (
            <p>{item?.description}</p>
          )}
          {item?.Restaurant_Item_Attributes && item.Restaurant_Item_Attributes.length > 0 && (
            <div className="w-100">
              <h6>Options:</h6>
              <Form>
              {item?.Restaurant_Item_Attributes
    ?.sort((a, b) => {
      // Sorting by name numerically or alphabetically
      return a?.Item_Attribute?.name?.localeCompare(b?.Item_Attribute?.name, undefined, { numeric: true });
    })?.map((attribute) => (
                  <Form.Group key={attribute.id} className="mb-3">
                    <Form.Label className="mb-2">{attribute?.Item_Attribute?.name} <br />
                      <small className="text-danger">{alertMessages[attribute.id]}</small>
                    </Form.Label>

                    <div className="d-flex flex-wrap">
                      {attribute?.Item_Attribute?.Item_Attribute_Options?.map((option) => (
                        <div className='checkbox-wrapper-47 m-0' key={option.id}>
                          <input
                            type="checkbox"
                            id={option.name}
                            name={option.name}
                            value={option.id}
                            onChange={() => handleOptionChange(option.id, option.price_modifier, attribute.id)}
                          />
                          <label htmlFor={option.name}>{option.name} {option?.price_modifier > 0 ? `+ $${option.price_modifier}` : null}</label>
                        </div>
                      ))}
                    </div>
                  </Form.Group>
                ))}
              </Form>
            </div>
          )}
    {/* ─────────── SPECIAL INSTRUCTIONS (clean Bootstrap styling) ─────────── */}
<Form.Group className="w-100 mb-4 px-2">
  <Form.Label className="fw-semibold mt-2 text-black d-block mb-2">
    Special Instructions
  </Form.Label>

  <div
    className="p-2 bg-white border"
    style={{
      borderRadius: 14,
      borderColor: "rgba(0,0,0,0.08)",
    }}
  >
    <Form.Control
      as="textarea"
      rows={2}
      placeholder="Add any special requests or dietary preferences…"
      value={special_instructions}
      onChange={(e) => setSpecialInstructions(e.target.value)}
      className="border-0 shadow-none"
      style={{
        resize: "vertical",
        minHeight: 70,
        fontSize: "0.95rem",
        lineHeight: 1.35,
        padding: "10px 12px",
        background: "transparent",
      }}
    />
  </div>

  <small className="text-muted d-block mt-1">
    Clear, concise notes help the kitchen get it right.
  </small>
</Form.Group>

        </div>
      </Modal.Body>

<div
  className="row align-items-center g-2 py-2 px-3 border-top bg-white"
  style={{ position: "sticky", bottom: 0, zIndex: 10 }}
>
  {/* Quantity Selector */}
  <div className="col-12 col-md-4">
    <div className="d-flex justify-content-center align-items-center bg-light rounded-pill p-2 border">
      <button
        type="button"
        className="btn btn-light border-0 d-flex align-items-center justify-content-center"
        onClick={handleDecrease}
        disabled={quantity <= 1}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <FontAwesomeIcon icon={faMinus} style={{ color: "#9d2a00" }} />
      </button>

      <span
        className="fw-bold mx-3"
        style={{ fontSize: "1rem", color: "#212529" }}
      >
        {quantity}
      </span>

      <button
        type="button"
        className="btn btn-light border-0 d-flex align-items-center justify-content-center"
        onClick={handleIncrease}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
        }}
      >
        <FontAwesomeIcon icon={faPlus} style={{ color: "#9d2a00" }} />
      </button>
    </div>
  </div>

  {/* Add to Order Button */}
  <div className="col-12 col-md-8 mt-2 mt-md-0">
    <button
      type="button"
      className="btn w-100 fw-semibold py-3 border-0"
      style={{
        backgroundColor: "#9d2a00",
        color: "#fff",
        borderRadius: "30px",
        fontSize: "1rem",
        opacity: disabledAddToCart ? 0.6 : 1,
        cursor: disabledAddToCart ? "not-allowed" : "pointer",
        transition: "background-color 0.2s ease",
      }}
      disabled={disabledAddToCart}
      onClick={!disabledAddToCart ? handleAddItem : undefined}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#b83500")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#9d2a00")}
    >
      {isLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          Adding…
        </>
      ) : (
        <>
          Add to Order • ${calculateTotalPrice()}
        </>
      )}
    </button>
  </div>
</div>


    </Modal>
  );
};

export default AddToCartModal;
